import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
   background: 'linear-gradient(#E3FDF5 0%, #FFE6FA 100%)',
   boxShadow: '0 4px 7px 3px rgba(255, 105, 135, .3)',
   padding: '0 30px',
   maxWidth: 500,
  },
});

export default function HomeMediaCard(props) {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardActionArea style={{ textDecoration: 'none' }}
                      href={props.link}>
        <CardMedia
          component="img"
          alt={props.alt}
          height="150"
          src={props.imageUrl}
          title={props.alt}
        />
        <CardContent>
          <Typography gutterBottom variant="h5"
                      component="h2"
                      color="textSecondary">
            {props.header}
          </Typography>
          <Typography variant="body2"
                      color="textSecondary"
                      component="p">
            {props.description}
          </Typography>
        </CardContent>
      </CardActionArea>
      {/*
      <CardActions>
        <Button size="small" color="primary">
          Share
        </Button>
        <Button size="small" color="primary">
          Learn More
        </Button>
      </CardActions>
      */}
    </Card>
  );
}
